import Button from "../Button/Button";
import Textfield from "@/Components/Input/Textfield";
import Modal, { ModalProps } from "../Modal/Modal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useUpdateCartItemByIndex } from "@/shared/hooks/useCartHook";
import { useModalMeta } from "@/shared/atoms/useModal";

const CartItemNoteModal = ({ onExit, ...props }: ModalProps) => {
  const { t } = useTranslation();
  const [{ index, cartItem }] = useModalMeta();
  const [note, setNote] = useState(cartItem.note || "");
  const updateProductByIndex = useUpdateCartItemByIndex();

  return (
    <Modal onExit={onExit} className="w-[95%] md:w-200" {...props}>
      <div className="mb-[1rem]">
        <Textfield
          onChange={(e) => setNote(e.target.value)}
          defaultValue={note}
          placeholder={t("posOrders.remark")}
          label={t("posOrders.enterYourComment")}
        />
      </div>
      <Button
        onClick={() => {
          updateProductByIndex(index, { ...cartItem, note });
          onExit();
        }}
      >
        {t("posOrders.save")}
      </Button>
    </Modal>
  );
};

export default CartItemNoteModal;
